import { inject, Injectable, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { interval } from 'rxjs';
import { delayWhen, filter, map } from 'rxjs/operators';
import { AppNotificationInterface } from '../models/app-notification.interface';
import { AppNotificationsService } from '../services/app-notifications.service';
import * as CoreStoreActions from './core-store.actions';

@Injectable()
export class CoreStoreEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _injector = inject(Injector);

  private get _appNotificationsService(): AppNotificationsService {
    return this._injector.get(AppNotificationsService);
  }

  pushAppNotification$ = createEffect(() =>
    this._actions$.pipe(
      ofType(CoreStoreActions.ActionTypes.PushAppNotification),
      map(({ notification }) => notification as AppNotificationInterface),
      filter(notification => notification.autoDismiss),
      delayWhen(() =>
        interval(this._appNotificationsService.autoDismissDefaultDuration),
      ),
      map(notification =>
        CoreStoreActions.dismissAppNotification({ id: notification['id'] }),
      ),
    ),
  );
}
